import { defineMessages } from 'react-intl';

export default defineMessages({
    submit: {
        id: 'tdic.endorsement.paperless-preference.Submit',
        defaultMessage: 'Submit'
    },
    back: {
        id: 'tdic.endorsement.paperless-preference.Back',
        defaultMessage: 'Back'
    },
    paperlessPreferredTooltip: {
        id: 'tdic.endorsement.paperless-preference.Select YES for paperless preferred to receive an email notification so that you can view your documents anytime at your convenience.',
        defaultMessage: 'Select YES for paperless preferred to receive an email notification so that you can view your documents anytime at your convenience.'
    },
    paperlessPreferenceLabel: {
        id: 'tdic.endorsement.paperless-preference.Paperless Preferred',
        defaultMessage: 'Paperless Preferred'
    },
    paperlessPreferenceSelectionTrue: {
        id: 'tdic.endorsement.paperless-preference.Yes',
        defaultMessage: 'Yes'
    },
    paperlessPreferenceSelectionFalse: {
        id: 'tdic.endorsement.paperless-preference.No',
        defaultMessage: 'No'
    },
    paperlessReviewsection: {
        id: 'tdic.endorsement.paperless-preference.Paperless review message',
        defaultMessage: 'Turn on paperless to streamline, save paper and access documents sooner. You’ll receive an email at [{pniEmail}] when new electronic notices are ready within your online account.'
    },
    paperlessReviewsubsection: {
        id: 'tdic.endorsement.paperless-preference.Paperless subsection',
        defaultMessage: 'Your preferences will apply only to this policy, and you can turn on paperless for each TDIC policy individually.'
    },
    paperlessPolicyDocuments: {
        id: 'tdic.endorsement.paperless-preference.Paperless - Policy Documents',
        defaultMessage: 'Paperless - Policy Documents'
    },
    paperlessInvoices: {
        id: 'tdic.endorsement.paperless-preference.Paperless - Invoices',
        defaultMessage: 'Paperless - Invoices'
    },
    paperlessPolicyDocumentsSubtitle: {
        id: 'tdic.endorsement.paperless-preference.All eligible notices for this policy will only be delivered electronically.',
        defaultMessage: 'All eligible notices for this policy will only be delivered electronically.'
    },
    paperlessInvoicesSubtitle: {
        id: 'tdic.endorsement.paperless-preference.All monthly invoices for this policy will only be delivered electronically.',
        defaultMessage: 'All monthly invoices for this policy will only be delivered electronically.'
    },
    popupMessage: {
        id: 'tdic.endorsement.paperless-preference.popupMessage.',
        defaultMessage: 'This means you\'ll start receiving monthly invoices for your policy premiums by mail.With paperless invoices, you can reduce paper use, stay organized and access your documents sooner.'
    },
    paperlessReviewMsgWithOutEmails: {
        id: 'tdic.endorsement.paperless-preference.Paperless review message with out email',
        defaultMessage: 'Email address needed in order to go paperless. Please go to policy [{policyNumber}], click Edit Policy Profile and complete a Profile Change to submit the email address for policy and billing notifications.'
    },
    paperlessConfirmyourPreference: {
        id: 'tdic.endorsement.paperless-preference.Confirm Your preference',
        defaultMessage: 'Confirm your preference'
    },
    paperlessAreYouSure: {
        id: 'tdic.endorsement.paperless-preference.Are you sure you want to receive mailed invoices for this policy?',
        defaultMessage: 'Are you sure you want to receive mailed invoices for this policy?'
    },
    paperlessturnoffPaperless: {
        id: 'tdic.endorsement.paperless-preference.You\'re turning off paperless for your invoices.',
        defaultMessage: 'You\'re turning off paperless for your invoices.'
    },
    paperlessGoBack: {
        id: 'tdic.endorsement.paperless-preference.GoBack',
        defaultMessage: 'Go Back'
    },
    paperlessYes: {
        id: 'tdic.endorsement.paperless-preference.Yes',
        defaultMessage: 'Yes'
    },

});
